import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import './HeaderNavigationArea.css';

@withRouter
@inject('translationsStore', 'commonStore', 'authStore')
@observer
export default class HeaderNavigationArea extends Component {
  constructor(props) {
    super(props);
    this.defaultNavigationItems = [
      {
        key: 'overview',
        label: props.translationsStore.translate('header.navigation.labelOverview'),
        pathname: '/dashboard',
        onClickFn: () => {
          props.history.push('/dashboard');
        },
      },
      ...((!this.props.authStore.isServiceManager)
        ? [{
          key: 'groupsmanager',
          label: props.translationsStore.translate('header.navigation.labelGroupsManager'),
          pathname: '/groups-manager',
          onClickFn: () => {
            props.history.push('/groups-manager');
          },
        },
      ] : []),
    ];
  }

  render() {
    const { commonStore, translationsStore, history, authStore } = this.props,
        { defaultNavigationItems } = this,
        navigationItems = [
          ...defaultNavigationItems,
          ...(authStore.isFleetManager || (!authStore.isServiceManager && commonStore.dealer && commonStore.dealer.masterApiUserUuid && commonStore.dealer.myfleetPermissionTrip)
              ? [
                {
                  key: 'trips',
                  label: translationsStore.translate('header.navigation.labelTrips'),
                  pathname: '/trips',
                  onClickFn: () => {
                    history.push('/trips');
                  },
                },
              ]
              : []),
          ...(authStore.isFleetManager || (!authStore.isServiceManager && commonStore.dealer && commonStore.dealer.masterApiUserUuid && commonStore.dealer.myfleetPermissionGeofence)
              ? [
                {
                  key: 'geofencemanager',
                  label: translationsStore.translate('header.navigation.labelGeofenceManager'),
                  pathname: '/geofence-manager',
                  onClickFn: () => {
                    history.push('/geofence-manager');
                  },
                },
              ]
              : []),
          ...(!authStore.isServiceManager && commonStore.dealer && commonStore.dealer.masterApiUserUuid && commonStore.dealer.myfleetPermissionTask
              ? [
                {
                  key: 'routetaskmanager',
                  label: translationsStore.translate('header.navigation.labelRouteTaskManager'),
                  pathname: '/myfleet-planning',
                  onClickFn: () => {
                    history.push('/myfleet-planning');
                  }
                }
              ]
              : []),
          ...(authStore.isServiceManager || (commonStore.dealer && commonStore.dealer.masterApiUserUuid && commonStore.dealer.serviceManagerEnabled)
            ? [
              {
                key: 'ordermanager',
                label: translationsStore.translate('header.navigation.labelOrderManager'),
                pathname: '/orders',
                onClickFn: () => {
                  history.push('/orders');
                }
              }
            ]
            : [])
        ];

    return (
        <div className="HeaderNavigationArea">
          {navigationItems.map((item) => {
            const itemClass = classNames({
              NavigationItem: true,
              NavigationItemActive: this.props.location.pathname.indexOf(item.pathname) === 0
            });
            return <div key={item.key} className={itemClass} onClick={item.onClickFn}>{item.label}</div>;
          })}
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Header/HeaderNavigationArea/HeaderNavigationArea.js